import React, { useEffect, useState } from 'react';
import {
  getAllCourses,
  getSearchCoursesAndExtraMaterial,
} from 'services/course';
import { useHistory } from 'react-router-dom';
import {
  ErrorUI,
  CourseCard,
  ExtraMaterialCard,
  SearchInput,
  Pagination,
} from 'components';
import { BlankBtn } from 'components/Buttons';

import { SearchContainer, SearchContainerListWrapper } from './style';
import ArrowBack from 'assets/icon/back-arrow.svg';

interface IListProps {
  searchValue: string;
}

const PAGE_SIZE = 60;

const List: React.FC<IListProps> = ({ searchValue }) => {
  const history = useHistory();
  const [trailId, setTrailId] = useState<string>();
  const [content, setContent] = useState<Array<any>>([]);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [page, setPage] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [offset, setOffset] = useState<number>(0);

  // carrega o trailId
  useEffect(() => {
    (async () => {
      const localTrail = await getAllCourses();
      if (localTrail && localTrail.length) {
        setTrailId(localTrail[0].trail_id);
      }
    })();
  }, []);

  // resetar para página inicial ao mudar busca
  useEffect(() => {
    setPage(0);
  }, [searchValue]);

  // busca paginada
  useEffect(() => {
    (async () => {
      const params: any = {
        text: searchValue,
        limit: PAGE_SIZE,                // sempre o tamanho da página
      };

      const currentOffset = page * PAGE_SIZE;
      if (currentOffset > 0) {
        params.offset = currentOffset;   // offset = quantos registros pular
      }

      const localSearchContent = await getSearchCoursesAndExtraMaterial(params);

      setContent(localSearchContent.data);
      setTotalElements(localSearchContent.total);
    })();
  }, [searchValue, page]);

  // total de páginas
  const totalPages = Math.ceil(totalElements / PAGE_SIZE);

  console.log(totalElements);
  console.log(PAGE_SIZE);
  console.log(totalPages);

  const handleNext = () => {
    if (page + 1 < totalPages) {
      setPage(prev => prev + 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handlePrev = () => {
    if (page > 0) {
      setPage(prev => prev - 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const hasResults = totalElements > 0 && content.length > 0;

  return (
    <SearchContainer>
      {/* <img
        src={ArrowBack}
        alt="arrow back"
        className="arrow-back"
        onClick={() => history.push('/home')}
      /> */}

      <div className="title">
        <h2>Busca</h2>
      </div>

      <div className="sm">
        <SearchInput initialSearchInput={searchValue} />
      </div>

      <SearchContainerListWrapper>
        {loading ? (
          <div style={{ padding: 24 }}>Carregando...</div>
        ) : hasResults && trailId ? (
          <div>
            <h2 className="info-search">
              Encontramos <span className="span-1">{totalElements}</span> resultados para
              <span className="span-2"> {searchValue}</span>
            </h2>

            <div
              className="list"
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                gap: 24,
                alignItems: 'stretch',
              }}
            >
              {content.map((el) => {
                const key =
                  el?.content_id ??
                  el?.id ??
                  `${el?.type ?? 'item'}-${el?.title ?? Math.random()}`;

                return el.type === 'CONTENT' ? (
                  <CourseCard
                    key={key}
                    courseId={el?.courses?.[0]?.course_id}
                    lessonId={el?.content_id}
                    profissional_avatar={el?.authors?.[0]?.avatar_url}
                    profissional_name={el?.authors?.[0]?.name}
                    profissional_specialty={el?.authors?.[0]?.info?.specialty}
                    thumbnail={el?.thumbnail}
                    title={el?.title}
                    trailiId={trailId}
                  />
                ) : (
                  <div key={key} className="material-extra">
                    <ExtraMaterialCard materialCourse={el} />
                  </div>
                );
              })}
            </div>

            {totalPages > 1 && (
              <Pagination
                quantity={totalElements}
                next={handleNext}
                preview={handlePrev}
                // você pode passar também a página atual e totalPages
              />
            )}
          </div>
        ) : (
          <div>
            <h2 className="info-search">
              Não encontramos nenhum resultado
              <span className="span-2"> {searchValue}</span>
            </h2>

            <ErrorUI
              errorText="Tente usar outras palavras-chave ou navegue pelo menu"
              boldText="MEU CURSO"
            />

            <div className="container-btn">
              <BlankBtn>ir para meu curso</BlankBtn>
            </div>
          </div>
        )}
      </SearchContainerListWrapper>
    </SearchContainer>
  );
};

export default List;